import classNames from "~/utils/classNames";

export const TextInputSkeleton = ({
    className,
    inputClassName,
  }: {
  className?: string
  inputClassName?: string
}) => (
    <div className={classNames('mb-2', className)}>
      <div className="h-5 w-1/4 bg-gray-300 rounded mb-1 animate-pulse"></div>
      <div className={classNames("h-10 bg-gray-200 rounded animate-pulse", inputClassName)}></div>
    </div>
);
